<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("assinatura", 2) }}
        </h1>
      </div>
      <div class="col-sm-4 text-md-end text-center">
        <router-link v-slot="{ href, navigate }" :to="'/admin/assinaturas/0'" custom>
          <a :href="href" class="btn btn-primary float-md-start" @click="navigate">
            <i class="bi bi-plus" /> {{ $t("criarAssinatura") }}
          </a>
        </router-link>
      </div>
    </div>
    <AssinaturasTable />
  </div>
</template>

<script>
import AssinaturasTable from './components/AssinaturasTable.vue';

export default {
  components: { AssinaturasTable },
};
</script>
